import { useEffect, useRef } from 'react';
import { AnnotationLayer } from 'pdfjs-dist';
import { Container } from './styled';
const linkService = {
    externalLinkEnabled: true,
    addLinkAttributes(link, url) {
        link.setAttribute('href', url);
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noreferrer noopener');
    },
    getDestinationHash: () => '#',
    getAnchorUrl: () => '#',
    setHash: () => { },
    executeNamedAction: () => { },
    executeSetOCGState: () => { },
    goToDestination: () => Promise.resolve(),
    goToPage: () => { },
    pagesCount: 0,
    page: 0,
    rotation: 0,
    isInPresentationMode: false,
};
export function LinkLayer(props) {
    const { page, scale } = props;
    const containerRef = useRef(null);
    useEffect(() => {
        const div = containerRef.current;
        if (!div) {
            return;
        }
        const viewport = page.getViewport({ scale });
        div.style.setProperty('--scale-factor', String(scale));
        div.replaceChildren();
        page.getAnnotations({ intent: 'display' }).then((annotations) => {
            const layer = new AnnotationLayer({
                div,
                accessibilityManager: null,
                annotationCanvasMap: null,
                annotationEditorUIManager: null,
                page,
                viewport,
                structTreeLayer: null,
            });
            layer.render({
                viewport,
                div,
                annotations,
                page,
                linkService,
                renderForms: false,
            });
        });
    }, [page, scale]);
    return <Container ref={containerRef} className="annotationLayer"/>;
}
